var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showSetReminder ? _c('div', {
    staticClass: "component-set-reminder"
  }, [_vm.pageIndex == 1 ? _c('div', {
    staticClass: "Layer-FullScreen follow-noPublic",
    on: {
      "click": function click($event) {
        _vm.showSetReminder = false;
      }
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("设置开抢提醒成功")]), _vm._m(0), _c('div', {
    staticClass: "QR-middle"
  }, [_c('div', {
    staticClass: "code-content"
  }, [_vm.wxQrCode ? _c('img', {
    attrs: {
      "src": _vm.wxQrCode + '?imageView2/1/w/240/h/240/interlace/1/q/85/'
    }
  }) : _vm._e(), _vm._l(4, function (n) {
    return _c('i', {
      key: n
    });
  })], 2)]), _c('div', {
    staticClass: "main-foot",
    on: {
      "click": function click($event) {
        _vm.showSetReminder = false;
      }
    }
  }, [_vm._v("知道了，暂不关注")])])]) : _vm._e(), _vm.pageIndex == 2 ? _c('div', {
    staticClass: "success-toast",
    class: {
      'center': _vm.positionStr == 'center',
      'top': _vm.positionStr == 'top',
      'bottom': _vm.positionStr == 'bottom'
    }
  }, [_c('p', {
    staticClass: "txt-p"
  }, [_vm._v(_vm._s(_vm.type == 1 ? "设置开抢提醒成功，系统将在开抢前5分钟发送提醒通知~" : "开抢提醒已经取消，您可能会抢不到哦"))])]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("长按二维码关注公众号，关注后系统将在开"), _c('br'), _vm._v("抢前5分钟发送提醒通知，未关注公众号收"), _c('br'), _vm._v("不到提醒哦~")]);
}];
export { render, staticRenderFns };